import logo from "@/assets/images/logos/test-product.svg";

const Header = () => {
  return (
    <div className="header">
      <div className="top">
        <div className="advertoriall logo">
          <img src={logo} alt="Site Logo" className="center p-3" />
        </div>
      </div>
      <div className="top_2"></div>
    </div>
  );
};

export default Header;
